import React, { Component } from 'react';
import classes from './Question.module.css';
import questionMark from '../../assets/images/question-mark.svg';

class Question extends Component {
    state = {}
    question = this.props.data;

    getAnswerList = () => {
        let answerList = [];
        for (let answerEntry of this.question.answers) {
            answerList.push(<li key={answerEntry.answerID} className={classes.ListItem} onClick={this.props.clickValuate.bind(this,answerEntry.answerID)}>{answerEntry.answer}</li>)
        }
        return answerList;
    }

    render() {
        return (<>
            <div className={classes.Question}>
                <div className={classes.QuestionMark} style={{ backgroundImage: `url(${questionMark})` }} />
                <h2>{this.question.question}</h2>
                <ul className={classes.AnswerList}>
                    {this.getAnswerList()}
                </ul>
            </div>
        </>);
    }
}

export default Question;
